var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 47,
    height: 47,
    rx: 7.567,
    fill: "url(#paint0_linear_1395_4692)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.139 34.006H33.4821C33.9849 34.006 34.459 33.8829 34.8758 33.6652C34.9119 33.6463 34.9494 33.6298 34.988 33.6166C38.0251 32.5734 40.2077 29.6922 40.2077 26.3012C40.2077 22.0305 36.7456 18.5684 32.4748 18.5684C32.2151 18.5684 31.9583 18.5812 31.7051 18.6062C31.3137 18.6449 30.9465 18.3815 30.8574 17.9984C30.0608 14.5756 26.991 12.0254 23.3256 12.0254C19.6037 12.0254 16.4959 14.6549 15.7586 18.1575C15.7085 18.3958 15.4964 18.5684 15.2529 18.5684C10.9821 18.5684 7.52002 22.0305 7.52002 26.3012C7.52002 30.572 10.9821 34.0341 15.2529 34.0341C15.4766 34.0341 15.6982 34.0246 15.9171 34.006H31.8106C32.0296 34.0246 32.2511 34.0341 32.4748 34.0341C32.6986 34.0341 32.9201 34.0246 33.139 34.006Z",
    fill: "#EDC150"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.451 22.1372C22.7984 21.4478 23.7826 21.4478 24.13 22.1372L25.0627 23.9886C25.2722 24.4044 25.7546 24.6042 26.1967 24.4583L28.1654 23.8087C28.8985 23.5668 29.5946 24.2628 29.3526 24.9959L28.703 26.9646C28.5571 27.4068 28.7568 27.8891 29.1727 28.0986L31.0241 29.0314C31.7136 29.3787 31.7136 30.363 31.0241 30.7103L29.1727 31.6431C28.7568 31.8525 28.5571 32.3349 28.703 32.7771L29.3526 34.7457C29.5946 35.4788 28.8985 36.1749 28.1654 35.9329L26.1967 35.2833C25.7546 35.1374 25.2722 35.3372 25.0627 35.753L24.13 37.6044C23.7826 38.2939 22.7984 38.2939 22.451 37.6044L21.5183 35.753C21.3088 35.3372 20.8265 35.1374 20.3843 35.2833L18.4156 35.9329C17.6825 36.1749 16.9865 35.4788 17.2284 34.7457L17.878 32.7771C18.0239 32.3349 17.8241 31.8525 17.4083 31.6431L15.5569 30.7103C14.8674 30.363 14.8674 29.3787 15.5569 29.0314L17.4083 28.0986C17.8241 27.8891 18.0239 27.4068 17.878 26.9646L17.2284 24.9959C16.9865 24.2628 17.6825 23.5668 18.4156 23.8087L20.3843 24.4583C20.8265 24.6042 21.3088 24.4044 21.5183 23.9886L22.451 22.1372Z",
    fill: "#0C0C0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6799 30.0802L22.5599 31.9602L26.3199 28.2002",
    stroke: "#EDC150",
    strokeWidth: 1.6215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_4692",
    x1: 23.5,
    y1: 0,
    x2: 23.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.1e9079ec6e9eb93c9fe7b760fb59da3b.svg";
export { ForwardRef as ReactComponent };